import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IContactInput } from "@/interfaces/contact.interface";
import contactService from "@/services/contact.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateContactProps = UpdateByIdProps<IContactInput>;

export type UseUpdateContactReturn = {
  update: (props: UpdateContactProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateContact = (): UseUpdateContactReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IContactInput>({
    operation: (formData, contactId) => contactService.update(formData, contactId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateContact;
